// Set the $ variable for WP
var $ = jQuery;


// Start AaltoMation
 $(window).scroll(function(){
	 inViewport();
 });

 $(window).resize(function(){
	 inViewport();
 });

 var h = window.innerHeight;

 function inViewport(){
	 

	 $('.aaltomation').each(function(){
		var divPos = $(this).offset().top,
 		topOfWindow = $(window).scrollTop();
		if( divPos < topOfWindow+h-100 ){
			var animationClass = $(this).data('animation-in')
			$(this).removeClass('aaltomation');
			$(this).addClass('animate__animated');
			$(this).addClass(animationClass);
		}

		if( divPos < 100 ){
			console.log('gone');
		}
	 });
 }

console.log('Aaltomation Has Loaded');
// End AaltoMation

$('iframe').on('load', function() {
	Foundation.reInit('equalizer');
});


// Hambugers
// https://jonsuh.com/hamburgers/
var forEach=function(t,o,r){if("[object Object]"===Object.prototype.toString.call(t))for(var c in t)Object.prototype.hasOwnProperty.call(t,c)&&o.call(r,t[c],c,t);else for(var e=0,l=t.length;l>e;e++)o.call(r,t[e],e,t)};

var hamburgers = document.querySelectorAll(".hamburger");
if (hamburgers.length > 0) {
  forEach(hamburgers, function(hamburger) {
    hamburger.addEventListener("click", function() {
      this.classList.toggle("is-active");
      $('.full-screen-nav').fadeToggle();
    }, false);
  });
}

// Make Gravity Forms act more like Material UI's forms
// https://get.foundation/building-blocks/blocks/floated-label-wrapper.html
$('input, textarea').on('input', function() {
	if(this.value !== ''){
		$(this).parent().parent().children("label").addClass('show');
	} else {
		$(this).parent().parent().children("label").removeClass('show');
	}
});

$( document ).ready(function() {
	const swiper = new Swiper('.swiper', {
	  // Optional parameters
		slidesPerView: 1,
		spaceBetween: 0,
		mousewheel: false,
		loop: false,
		effect: 'fade',
	  fadeEffect: {
	    crossFade: true
	  },
		keyboard: {
		  enabled: true,
		  onlyInViewport: false,
		},
		breakpoints: {
		  // when window width is >= 480px
		  640: {
		    slidesPerView: 1,
		    spaceBetween: 15
		  },
		  // when window width is >= 640px
		  1024: {
		    slidesPerView: 1,
		    spaceBetween: 30
		  }
		},

	  // If we need pagination
	  pagination: {
	    el: '.swiper-pagination',
	    type: 'bullets',
	  },

	  // Navigation arrows
	  navigation: {
	    nextEl: '.swiper-button-next',
	    prevEl: '.swiper-button-prev',
	  },

	  // And if we need scrollbar
	  scrollbar: {
	    el: '.swiper-scrollbar',
	    draggable: true,
	  },
	});
});